import { render, staticRenderFns } from "./createOrEdit.vue?vue&type=template&id=44f6b750&scoped=true&"
import script from "./createOrEdit.vue?vue&type=script&lang=ts&"
export * from "./createOrEdit.vue?vue&type=script&lang=ts&"
import style0 from "./createOrEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./createOrEdit.vue?vue&type=style&index=1&id=44f6b750&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6b750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VContainer,VFlex,VForm,VIcon,VLayout,VListTile,VListTileTitle,VRadioGroup,VSelect,VTextField,VTextarea})
